import {
    Component,
    ViewEncapsulation,
    Input,
    OnChanges,
    SimpleChanges,
    EventEmitter,
    Output,
    OnInit,
} from '@angular/core';
import { trigger, transition, style, animate } from '@angular/animations';
import { Subscription, of } from 'rxjs';
import { delay } from 'rxjs/operators';

@Component({
    selector: 'roblex-alert-message',
    templateUrl: './alert-message.component.html',
    styleUrls: [ './alert-message.component.scss' ],
    encapsulation: ViewEncapsulation.None,
    animations: [
        trigger('fadeInOut', [
            transition(':enter', [
                // :enter is alias to 'void => *'
                style({ opacity: 0 }),
                animate(100, style({ opacity: 1 })),
            ]),
            transition(':leave', [
                // :leave is alias to '* => void'
                animate(100, style({ opacity: 0 })),
            ]),
        ]),
    ],
})
export class AlertMessageComponent implements OnInit, OnChanges {
    /**
     * Determines whether dismissible on
     */
    onDismissible: Subscription = new Subscription();
    /**
     * Input  of alert message component
     */
    @Input() toggle = false;
    /**
     * Input  of alert message component
     */
    @Input() dismissible: boolean;
    /**
     * Input  of alert message component is default 10 seconds
     */
    @Input() dismissOnTimeout = 10000;
    /**
     * Input  of alert message component
     */
    @Input() title: string;
    /**
     * Input  of alert message component
     */
    @Input() type: 'error' | 'info' | 'success' | 'warning';
    /**
     * Input  of alert message component
     */
    @Input() class: string;
    /**
     * Output closed  of alert message component
     */
    @Output() public closed: EventEmitter<boolean> = new EventEmitter();
    /**
     * on init
     */
    ngOnInit(): void {
        //
    }
    /**
     * on changes
     * @param change SimpleChanges
     */
    ngOnChanges(change: SimpleChanges): void {
        this.onDismissible.unsubscribe();
        if ( change.toggle && change.dismissible ) {
            if ( this.dismissible ) {
                this.onDismissible = of(true)
                    .pipe(delay(this.dismissOnTimeout))
                    .subscribe(() => {
                        this.toggle = false;
                        this.closed.emit(this.toggle);
                        this.onDismissible.unsubscribe();
                    });
            }
        }
    }

    /**
     * Determines whether click toggle on
     */
    onClickToggle(): void {
        this.onDismissible.unsubscribe();
        this.toggle = !this.toggle;
        this.closed.emit(this.toggle);
    }

    /**
     * Gets class by type
     * @param type string
     * @returns any
     */
    getClassByType(type: string): any {
        switch (type) {
            case 'error':
                return { 'alert-danger': true };
            case 'info':
                return { 'alert-warning': true };
            case 'success':
                return { 'alert-info': true };
            case 'warning':
                return { 'alert-success': true };
            default:
                return { 'alert-warning': true };
        }
    }

    /**
     * Gets title by type
     * @returns string
     */
    getTitleByType(title: string, type: string): string {
        if ( title ) {
            return title;
        }
        switch (type) {
            case 'error':
                return 'Error, ';
            case 'info':
                return 'Info, ';
            case 'success':
                return 'Exito, ';
            case 'warning':
                return 'Advertencia, ';
            default:
                return '';
        }
    }
}
